export const COMMAND_LOG_SET_ACTIVE_INDEX = "COMMAND_LOG_SET_ACTIVE_INDEX";
export const COMMAND_LOG_SET_VISUAL_DATA = "COMMAND_LOG_SET_VISUAL_DATA";
export const NETWORK_LOG_SET_ACTIVE_INDEX = "NETWORK_LOG_SET_ACTIVE_INDEX";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_SCREENSHOT_URL_FOR_VIDEO = "SET_SCREENSHOT_URL_FOR_VIDEO";
export const SET_LAST_PLAYED_SECOND = "SET_LAST_PLAYED_SECOND";
export const SET_VIDEO_URL = "SET_VIDEO_URL";
export const SET_CHANGE_FROM_VIDEO_COMP = "SET_CHANGE_FROM_VIDEO_COMP";
export const SET_IS_VIDEO_PLAYABLE = "SET_IS_VIDEO_PLAYABLE";
export const SET_IS_VIDEO_PLAYING = "SET_IS_VIDEO_PLAYING";
